import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Enviroment } from './env';
import 'rxjs/Rx';

@Injectable({
  providedIn: 'root'
})
export class InventarioService {

  basicHeaders: any;
  basicHeadersCloud: any;
  token: string;

  constructor(private http: HttpClient) {
    this.token = sessionStorage.getItem('token');

    this.basicHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `${this.token}`
    })
  }

  Listar_Inventario(body): Promise<any> {
    return this.http.post<any>(Enviroment.url_backend + '/inventory/ListarInventario', body, { headers: this.basicHeaders }).toPromise();
  }



}